import { http } from "../ConnectApi/ConnectApi";

export async function closePixToTokenController(data: { amount: Number; token: string; receiverAddress: string }) {
  try {
    const response = await http.post('business/pay-in/pix-to-token', data, {
      withCredentials: true
    });

    return response;
  } catch (error: any) {
    console.error('Error during request:', error.response?.data || error.message);
    throw error;
  }
}
